import React, { useContext } from 'react'
import { ReducerDispatchContext, ReducerContext } from '../reducers/reducerContext.js';
import CalculatorButton from '../components/calculator/CalculatorButton'
import { fetchOffersIfNeeded } from '../actions/actionsApiOffer'

export default function ContCalculatorButton(props) {
  const dispatch = useContext(ReducerDispatchContext);
  const globalstate = useContext(ReducerContext);

  function onCalcOpen(vehicle) {
    fetchOffersIfNeeded(globalstate, dispatch, vehicle, null);
  }

  return (
    <CalculatorButton
      onCalcOpen={onCalcOpen}
    />
  );
}
